export const SMOOTH = 'smooth';
export const WAVY = 'wavy';
// deprecated on backend but some user might still have it within their consultation
export const DEPRECATED_CURLY = 'curly';
export const THREE_A = 'type_3a';
export const THREE_B = 'type_3b';
export const THREE_C = 'type_3c';
export const VERY_CURLY = 'very_curly';
export const FRIZZY = 'frizzy';
export const ZIGZAG = 'zigzag';

// export const DEPRECATED_WAVY = 'wavy';

// Type 2A - Soft Waves
export const TWO_A = 'type_2a';
// Type 2B - Wavy
export const TWO_B = 'type_2b';
// Type 2C - Deep Waves or Loose Curls
export const TWO_C = 'type_2c';
